import { render, staticRenderFns } from "./VwDelete.vue?vue&type=template&id=100f780a&lang=pug&"
import script from "./VwDelete.vue?vue&type=script&lang=ts&"
export * from "./VwDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwDelete.vue"
export default component.exports